/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
    url     => router path
    name    => name to display in sidebar
    slug    => router path name
    icon    => Feather Icon component/icon name
    tag     => text to display on badge
    tagColor  => class to apply on badge element
    submenu   => submenu of current item (current item will become dropdown )
    isDisabled  => disable sidebar item/group
==========================================================================================*/

export default [
  {
    header: '总览',
    auth: 'admindashboard'
  },
  {
    url: '/dashboard',
    name: "仪表板",
    icon: 'HomeIcon',
    auth: 'admindashboard'
  },
  {
    header: '设置与管理',
    auth: 'settingbase,settingng,settingactivity,settingspeed,settingslide,settingbase,adminlist,adminadd,userlist,useradd,usergroup,userbank,moneybankSend,moneybankReceive,moneybankPay,lotterylist,lotterytime,lotterytimeLhc,lotterydata'
  },
  {
    url: null,
    name: '程序设置',
    icon: 'SettingsIcon',
    submenu: [
      {
        url: '/setting/base',
        name: '基础设置',
        auth: 'settingbase'
      },
      {
        url: '/setting/notification',
        name: '风控设置',
        auth: 'settingnotification'
      },
      {
        url: '/setting/ng',
        name: 'NG设置',
        auth: 'settingng'
      },
      {
        url: '/setting/activity',
        name: '活动设置',
        auth: 'settingactivity'
      },
	{
	  url: '/setting/appupdate',
	  name: 'APP更新',
	  auth: 'settingappupdate'
	},
      {
        url: '/setting/speed',
        name: '线路设置',
        auth: 'settingspeed'
      },
      {
        url: '/setting/slide',
        name: '轮播设置',
        auth: 'settingslide'
      },
      {
        url: '/setting/virtual',
        name: '虚拟币设置',
        auth: 'settingbase'
      }
    ]
  },
  {
    url: '/admin/list',
    name: '管理员管理',
    icon: "UsersIcon",
    auth: 'adminlist'
  },
  {
    url: null,
    name: '会员管理',
    icon: "UserIcon",
    submenu: [
      {
        name: '会员列表',
        url: '/user/list',
        auth: 'userlist'
      },
      {
        name: '会员用户组',
        url: '/user/group',
        auth: 'usergroup'
      },
      {
        name: '会员银行卡',
        url: '/user/bank',
        auth: 'userbank'
      },
      {
        name: '会员推广链接',
        url: '/user/link',
        auth: 'userlist'
      }
    ]
  },
  {
    url: null,
    name: '资金管理',
    icon: 'CreditCardIcon',
    submenu: [
      {
        url: '/money/send',
        name: '提款银行',
        auth: 'moneybankSend'
      },
      {
        url: '/money/receive',
        name: '收款银行',
        auth: 'moneybankReceive'
      },
      {
        url: '/money/pay',
        name: '第三方',
        auth: 'moneybankPay'
      }
    ]
  },
  {
    url: null,
    name: '彩票管理',
    icon: 'LifeBuoyIcon',
    submenu: [
      {
        url: '/lottery/list',
        name: '彩种管理',
        auth: 'lotterylist'
      },
      {
        url: '/lottery/played',
        name: '玩法管理',
        auth: 'lotteryplayed'
      },
      {
        url: '/lottery/time',
        name: '时间管理',
        auth: 'lotterytime'
      },
      {
        url: '/lottery/timeLhc',
        name: '时间管理(LHC)',
        auth: 'lotterytimeLhc'
      },
      {
        url: '/lottery/data',
        name: '开奖数据',
        auth: 'lotterydata'
      },
      {
        url: '/lottery/plan',
        name: '计划管理',
        auth: 'lotterydata'
      }
    ]
  },
  {
    header: '记录与报表',
    auth: 'lotterybet,gamebet,moneycash,moneyrecharge,userlog,useractivity,adminlog,reportuser,reportlottery,reportgame,reportteam'
  },
  {
    url: null,
    name: '注单记录',
    icon: 'ArchiveIcon',
    submenu: [
      {
        url: '/record/lottery',
        name: '彩票注单',
        auth: 'lotterybet'
      },
      {
        url: '/record/game',
        name: '游戏注单',
        auth: 'gamebet'
      },
    ]
  },
  {
    url: null,
    name: '资金记录',
    icon: 'DollarSignIcon',
    submenu: [
      {
        url: '/record/cash',
        name: '提现记录',
        auth: 'moneycash'
      },
      {
        url: '/record/recharge',
        name: '充值记录',
        auth: 'moneyrecharge'
      }
    ]
  },
  {
    url: null,
    name: '日志记录',
    icon: 'FileIcon',
    submenu: [
      {
        url: '/record/user',
        name: '会员日志',
        auth: 'userlog'
      },
      {
        url: '/record/activity',
        name: '活动日志',
        auth: 'useractivity'
      },
      {
        url: '/record/admin',
        name: '管理员日志',
        auth: 'adminlog'
      }
    ]
  },
  {
    url: null,
    name: '报表概览',
    icon: 'PieChartIcon',
    submenu: [
      {
        url: '/report/user',
        name: '会员报表',
        auth: 'reportuser'
      },
      {
        url: '/report/lottery',
        name: '彩票报表',
        auth: 'reportlottery'
      },
      {
        url: '/report/game',
        name: '游戏报表',
        auth: 'reportgame'
      },
      {
        url: '/report/team',
        name: '团队报表',
        auth: 'reportteam'
      }
    ]
  },
  {
    header: '杂项',
    auth: 'articlelist,articleadd,othertrash'
  },
  {
    url: '/article/list',
    name: '文章列表',
    icon: 'BookIcon',
    auth: 'articlelist'
  },
  {
    url: '/other/clean',
    name: '数据清理',
    icon: 'Trash2Icon',
    auth: 'othertrash'
  },
  // {
  //   url: '/other/update',
  //   name: '程序更新',
  //   icon: 'RefreshCwIcon',
  //   auth: 'otherupdate'
  // }
]
